export default __webpack_public_path__ + "static/media/linkedin_logo.40a13fa6.svg";